import React, { useState } from 'react'
import { auctionLocation } from '../../data';
import { ArrowDropDown, Search } from '@mui/icons-material'
import { useTranslation } from 'react-i18next';

const SaleSearch = ({
    categories,
    handleSearchClick,
    setCategory,
    setLocation,
    query, setQuery,
    minPrice, setMinPrice,
    maxPrice, setMaxPrice
}) => {
    const [selectedVelayat, setSelectedVelayat] = useState('');
    const [showVelayatDropdown, setShowVelayatDropdown] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const { t } = useTranslation()

    const handleVelayatSelect = (velayat) => {
        setSelectedVelayat(velayat);
        setShowVelayatDropdown(false);
        setLocation(velayat)
    };

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setShowCategoryDropdown(false);
        setCategory(category)
    };

    const handleMinPriceChange = (e) => {
        const value = e.target.value ? parseInt(e.target.value, 10) : '';
        setMinPrice(isNaN(value) ? '' : value);
    };

    const handleMaxPriceChange = (e) => {
        const value = e.target.value ? parseInt(e.target.value, 10) : '';
        setMaxPrice(isNaN(value) ? '' : value);
    };


    return (
        <form className='xl:flex items-center xl:mt-4
                         justify-between gap-4 mb-4 xl:mb-8'>
            {/* category select input */}
            <div className="relative xl:w-[25%]">
                <div className="relative">
                    <input
                        type="text"
                        name="act"
                        value={selectedCategory}
                        placeholder={t('type')}
                        readOnly
                        className="w-full pl-4 pr-8 py-2 border border-border 
                                   rounded cursor-pointer focus:outline-none 
                                   focus:ring-2 focus:ring-indigo-500 
                                   dark:bg-dark-box dark:border-dark-border
                                   dark:text-dark-text bg-white shadow-inner"
                        onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                    />
                    <ArrowDropDown
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                   text-blackOpacity dark:text-dark-text"
                    />
                </div>
                {showCategoryDropdown && (
                    <div className="absolute top-full left-0 w-full 
                                    border z-10 max-h-64 overflow-y-auto bg-white 
                                    dark:bg-dark-box shadow-lg  border-secondary
                                    dark:border-dark-border dark:text-dark-text
                                    p-2 rounded-md input-table">
                        {categories.map((c, id) => (
                            <div
                                key={id}
                                onClick={() => handleCategorySelect(c)}
                                className="px-4 py-2 hover:bg-secondary 
                                           cursor-pointer dark:hover:bg-dark-border"
                            >
                                {c}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className='xl:w-[25%] flex border border-border 
                            bg-white shadow-inner rounded mt-2 xl:mt-0
                            dark:bg-dark-box dark:border-dark-border'>
                {/* Min Price Input */}
                <input
                    type="number"
                    placeholder={t('price')}
                    className="w-full px-4 py-2 rounded-l bg-white
                               dark:bg-dark-box focus:ring-2
                               focus:outline-none focus:ring-indigo-500
                               dark:text-dark-text"
                    value={minPrice}
                    onChange={handleMinPriceChange}
                />

                {/* Max Price Input */}
                <input
                    type="number"
                    placeholder={t('price')}
                    className="w-full px-4 py-2 border-l border-l-border
                               rounded-r dark:bg-dark-box focus:outline-none
                               focus:ring-2 focus:ring-indigo-500 
                               dark:text-dark-text"
                    value={maxPrice}
                    onChange={handleMaxPriceChange}
                />
            </div>

            {/* place select input */}
            <div className="relative xl:w-[25%] mt-2 xl:mt-0">
                <div className='relative flex gap-4'>
                    <input
                        type="text"
                        name="velayat"
                        value={selectedVelayat}
                        placeholder={t('select_province')}
                        readOnly
                        className="w-full pl-4 pr-8 py-2 border border-border rounded 
                                   bg-white dark:bg-dark-box dark:border-dark-border 
                                   focus:outline-none focus:ring-2 cursor-pointer
                                   focus:ring-indigo-500 dark:text-dark-text shadow-inner"
                        onClick={() => setShowVelayatDropdown(!showVelayatDropdown)}
                    />
                    <ArrowDropDown
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 
                                   text-blackOpacity dark:text-dark-text"
                    />
                </div>
                {showVelayatDropdown && (
                    <div className="absolute top-full left-0 w-full bg-white 
                                    border z-10 max-h-64 overflow-y-auto
                                    dark:bg-dark-box shadow-lg  border-secondary
                                    dark:border-dark-border dark:text-dark-text
                                    p-2 rounded-md input-table">
                        {auctionLocation.map((velayat) => (
                            <div
                                key={velayat.id}
                                onClick={() => handleVelayatSelect(velayat.title)}
                                className="px-4 py-2 hover:bg-secondary 
                                           cursor-pointer dark:hover:bg-dark-border"
                            >
                                {velayat.title}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* search input */}
            <input
                type="search"
                placeholder={t('search')}
                className="px-4 py-2 border border-border xl:w-[25%]
                           bg-white rounded w-full mt-2 xl:mt-0
                           focus:outline-none focus:ring-2 shadow-inner
                           focus:ring-indigo-500 dark:text-white 
                           dark:bg-dark-box dark:border-dark-border"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
            />

            <button className='bg-primary py-2 px-4 text-white
                               rounded mt-2 xl:mt-0 w-full xl:w-max'
                onClick={handleSearchClick}>
                <Search />
            </button>
        </form>
    )
}

export default SaleSearch